export interface ProgressiveProfile {
  onSsg(): Promise<void>;

  onClient(): void;
}

export default abstract class BaseProgressiveProfile implements ProgressiveProfile {
  protected readonly formId: string;

  constructor({ formId }: { formId: string }) {
    this.formId = formId;
  }

  abstract onSsg(): Promise<void>;
  abstract onClient(): void;
}
